import React from "react";
import Image from "../../../components/elements/Image";
import Logo from "../../../assets/images/logo-memory-doodle-stack.svg";
import ResetPasswordForm from "../../../components/sections/front/Authentication/ResetPasswordForm";

const ResetPassword = () => {
  return (
    <section className="relative min-h-[calc(100vh-6rem)] py-10 flex items-center overflow-hidden bg-md-pink-light-2">
      <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
        <div className="w-full max-w-lg mx-auto space-y-8">
          <div className="h-36">
            <Image src={Logo} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-contain"} />
          </div>
          <div className="relative bg-white shadow-md shadow-md-pink/10 py-6 px-6 rounded-xl space-y-6">
            <h2 className="text-2xl font-semibold text-md-dark text-center">Reset Password</h2>
            <div className="text-base tracking-tight text-neutral-600 text-center">
              Please enter a new password for your account.
            </div>
            <ResetPasswordForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
